// import { cutliststatusreport } from '../../app/models/Restoration';
import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../../app/api/agent';
import {
  adlEmployeeDetails,
  employeeLockedInfo,
  EmpOption,
  ShiftDetail,
  shiftMasterData,
  shiftRoasterChangeData,
  shiftRoasterData,
  shiftRoasterExt,
  ShiftUpdate,
} from '../../app/models/adlData';

export default class ADLtrackingStore {
  getallemployeedetails: any[] = [];
  employeeLockedDetailsinfo: employeeLockedInfo[] = [];
  addNewEmployee: adlEmployeeDetails[] = [];
  employeeDetailbyId: adlEmployeeDetails[] = [];
  newShiftDetails: shiftMasterData[] = [];
  shiftRoasterUpload: shiftRoasterData[] = [];
  empIds: EmpOption[] = [];
  updatedShiftRoster: ShiftUpdate[] = [];
  shiftRosterList: ShiftDetail[] = [];
  shiftRosterCount: number = 0;
  plEmpIdGet: any[] = [];
  shiftRoastergetData: any[] = [];
  shiftCodeList: any[] = [];
  shiftChange: any[] = [];
  shiftExtendition: any[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  employeeDetails = async (pageNumber: number, pageSize: number, employeeId: string) => {
    try {
      const response = await agent.adltracking.getEmployeedetails(
        pageNumber,
        pageSize,
        employeeId
      );
      runInAction(() => {
        this.getallemployeedetails = response.data;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
    }
  };

  assignNewEmployee = async (adlEmployeeDetails: adlEmployeeDetails) => {
    try {
      const response = await agent.adltracking.assingHead(adlEmployeeDetails);
      runInAction(() => {
        this.addNewEmployee = response.data;
        toast.success('Reporting Head Assigned Successfully');
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  countTotalEmployee = async (employeeId: string) => {
    try {
      const response = await agent.adltracking.employeeCount(employeeId);
      return response.data;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  getReportingHeadCall = async (employeeId: string) => {
    try {
      const response =
        await agent.adltracking.getEmployeeinformationbyID(employeeId);
      // runInAction(() => {
      //   this.employeeDetailbyId = response.data;
      // });
      return response.data;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };
  deleteEmployeeReportingHead = async (employeeId: string) => {
    try {
      const response = await agent.adltracking.removeEmplyee(employeeId);
      runInAction(() => {
        this.employeeDetailbyId = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  addNewShiftDetails = async (shiftDetails: shiftMasterData) => {
    try {
      const response = await agent.adltracking.addNewShift(shiftDetails);
      runInAction(() => {
        this.newShiftDetails = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  shiftTotalnumber = async () => {
    try {
      const response = await agent.adltracking.countShiftData();
      return response.data;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  shiftNameCountUpdate = async (shiftname: string) => {
    try {
      const response = await agent.adltracking.countShiftName(shiftname);
      return response.data;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };
  getAllshiftDetails = async () => {
    try {
      const response = await agent.adltracking.returnAllShiftDetails();
      runInAction(() => {
        this.newShiftDetails = response.data;
      });
      return response.data;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  addShiftRoaster = async (shifUploadRoasterData: shiftRoasterData[]) => {
    try {
      const response = await agent.adltracking.uploadShiftRoaster(
        shifUploadRoasterData,
      );
      runInAction(() => {
        this.shiftRoasterUpload = response.data;
        toast.success('Shift Roster Uploaded Successfully.');
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  getEmployeesUnderLead = async (empId: string) => {
    try {
      const response = await agent.adltracking.getEmpUnderLead(empId);
      const formattedData: EmpOption[] = response.data.map((empId: string) => ({
        id: empId,
        text: empId,
        value: empId,
      }));
      runInAction(() => {
        this.empIds = formattedData;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again!');
    }
  }

  updateShiftRoster = async (shiftRosterUpdatedData: ShiftUpdate) => {
    try {
      const response = await agent.adltracking.updateShiftRoster(shiftRosterUpdatedData);
      runInAction(() => {
        this.updatedShiftRoster = response.data;
        toast.success('Shift Roster Updated Successfully');
      })
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  }

  loadShiftDetails = async (empID: string, pageNo: number, pageSize: number) => {
    try {
      const response = await agent.adltracking.shiftRosterDetails(empID, pageNo, pageSize);
      runInAction(() => {
        this.shiftRosterList = response.data.shiftDetails;
        this.shiftRosterCount = response.data.count;
      })
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  }

  loadLeadId = async () => {
    try {
      const response = await agent.adltracking.leadID();
      runInAction(() => {
        this.plEmpIdGet = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  loadShiftRoasterDatabyPL = async (
    startDate: string,
    endingDate: string,
    leadId: string,
  ) => {
    try {
      const response = await agent.adltracking.shiftDatabyPlwise(
        startDate,
        endingDate,
        leadId,
      );
      return response.data.map((item: any) => ({
        lead: item.lead,
        employeeId: item.employeeId,
        shiftCode: item.shiftCode,
        startDate: item.startDate,
        shiftExtension: item.shiftExtendition,
        shiftExtensionDate: item.shiftExtensionDate,
      }));
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  loadShiftcode = async () => {
    try {
      const response = await agent.adltracking.loadingShiftcode();
      runInAction(() => {
        this.shiftCodeList = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  chanageShift = async (shiftChangeDetails: shiftRoasterChangeData) => {
    try {
      const response = await agent.adltracking.shiftChange(shiftChangeDetails);
      runInAction(() => {
        this.shiftChange = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  extShiftData = async (shiftExtdata: shiftRoasterExt) => {
    try {
      const response = await agent.adltracking.shiftExtendition(shiftExtdata);

      runInAction(() => {
        this.shiftExtendition = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };
  getLockedEmployeeDetails = async (page: number, size: number) => {
    try {
      const response = await agent.adltracking.loadLockedEmployeeDetails(
        page,
        size,
      );
      return response.data;
    } catch (error) {
      toast.error('Something went wrong. Please try again!');
    }
  };
  unlockEmployee = async (employeeLockedInfos: employeeLockedInfo) => {
    try {
      await agent.adltracking.unLockEmployee(employeeLockedInfos);
      toast.success('Employee unlocked successfully!');
    } catch (error) {
      toast.error('Something went wrong. Please try again!');
    }
  };
  numberofLockedEmployee = async () => {
    try {
      const response = await agent.adltracking.getLockedEmployeeCount();
      return response.data;
    } catch (error) {
      toast.error('Something went wrong. Please try again!');
    }
  };
}
